import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isEmpty } from 'lodash';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap, distinctUntilChanged } from 'rxjs/operators';
import { Site } from '../../../../sites';
import { Subject } from './../../../../subjects/Subject';
import { AdminSubjectsStorage } from './../../../shared/admin-subjects-storage';

@Component({
    selector: 'subject-select',
    template: require('./subject-select.component.html'),
    styles: [require('./shared/select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectSelectComponent {
    @Input()
    public control: FormControl;

    @Input()
    public set sites(sites: Site[]) {
        this.sites$.next(sites);
        this.control.setValue([]);

        this.disabled = isEmpty(sites);
        
        if (this.disabled) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }

    @Input()
    @HostBinding('class.disabled')
    public disabled = false;

    public selectedSubjects$: Observable<Subject[]>;
    public subjects$: Observable<Subject[]>;
    private sites$ = new BehaviorSubject<Site[]>([]);

    constructor(private subjectsStorage: AdminSubjectsStorage) { }

    public ngOnInit() {
        this.subjects$ = this.sites$.pipe(switchMap(sites =>
            isEmpty(sites)
                ? of([])
                : this.subjectsStorage.getSiteSubjects(sites[0].siteId))
        );

        this.selectedSubjects$ = this.control.valueChanges.pipe(distinctUntilChanged());
    }

    public onSelectedItemsChange(selectedSubjects: Subject[]) {
        this.control.setValue(selectedSubjects);
    }
}
